import { FormSection} from '@hai/ui-react';
import { Formik } from 'formik';
import React from 'react';
import { FormBuilder, FormFieldType, FormLayout } from 'src/js/component/form-builder';

export const FormBuilderGridTest: React.FunctionComponent = () => (
  <div className="test-zone w100">
    <Formik
      initialValues={{nodePort: 4000}}
      onSubmit={() => {
        // console.log('submit');
      }}> 
       <FormSection className="hai-mb-6" title={'source'} key={'source'}>
               
                      <FormBuilder
                        mode="formik"
                        translationPrefixLabels="settings.services.nmos.field"
                        translationPrefixEnums="settings.services.nmos.enums"
                        layout={FormLayout.THREE_COLUMNS_GRID}
                        fields={[
                          {
                            type: FormFieldType.INPUT_NUMBER,
                            name: 'nodePort',
                            placeholder: '8001',
                            hint: '100 - 8999',
                          },
                          {
                            type: FormFieldType.INPUT_NUMBER,
                            name: 'nodePort',
                            placeholder: '8001',
                            hint: '100 - 8999',
                          },
                          {
                            type: FormFieldType.INPUT_NUMBER,
                            name: 'nodePort',
                            placeholder: '8001',
                            hint: '100 - 8999',
                          },
                          {
                            type: FormFieldType.INPUT_NUMBER,
                            name: 'nodePort',
                            placeholder: '8001',
                            hint: '100 - 8999',
                          },
                        /*  {
                            type: FormFieldType.LINE_BREAK,
                          },*/
                          {
                            type: FormFieldType.INPUT_NUMBER,
                            name: 'nodePort',
                            placeholder: '8001',
                            hint: '100 - 8999',
                          },
                          {
                            type: FormFieldType.INPUT_NUMBER,
                            name: 'nodePort',
                            placeholder: '8001',
                            hint: '100 - 8999',
                          },
                        ]}
                      />
               </FormSection>  
                  </Formik>
  </div>

);
